<template>
    <div class="card">
        <h2>Tags:</h2>
        <code v-for="tag in $store.state.tags" :key="tag.id">
                    {{ tag.name }}
                </code>
        <br>
        <input type="text" v-model="newTag" class="input">
        <br>
        <button @click="addTag" class="button">
            Add Tag
        </button>
    </div>
</template>

<script>
import { supabase } from '@/supabase.js'


export default {
    name: 'Tags',
    created() {
    },
    data() {
        return {
            newTag: ''
        }
    },
    methods: {
        addTag() {
            this.$store.dispatch('addTag',
                {
                    name: this.newTag.toLowerCase().replace(/\s+/g, '-'),
                    user_id: supabase.auth.currentUser.id,
                });
            this.newTag = ''
        }
    }

}

</script>